import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { AnimalMetadataComponentAbstract } from '../../metadata-components/animal-metadata/animal-metadata.component.abstract';

@Component({
  selector: 'app-animal-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './animal-metadata-v2.component.html',
})
export class AnimalMetadataV2Component extends AnimalMetadataComponentAbstract {}
